import { IndustryPageTemplate } from "@/components/templates/IndustryPageTemplate";
import { aiContentCluster, getRelatedMoneyPages, getRelatedInsightPages } from "@/data/contentClusters";

const pageData = aiContentCluster.industryPages.find(p => p.slug === "content-marketing-b2b")!;
const relatedMoney = getRelatedMoneyPages("ai-content").map(p => ({ title: p.title, slug: p.slug, pillarSlug: p.pillarSlug }));
const relatedInsights = getRelatedInsightPages("ai-content").map(p => ({ title: p.title, slug: p.slug }));

export default function ContentMarketingB2BPage() {
  return (
    <IndustryPageTemplate
      page={pageData}
      relatedMoneyPages={relatedMoney}
      relatedInsightPages={relatedInsights}
    />
  );
}
